import { defineMessages } from '@jutro/locale';

export default defineMessages({
    backToDashboard: {
        id: 'ml.gateway.views.MLViewAllPoliciesPage.Back to Dashboard',
        defaultMessage: 'Back to Dashboard'
    },
    weFoundxCountResults: {
        id: 'ml.gateway.views.MLViewAllPoliciesPage.We found xCount results',
        defaultMessage: 'We found {spanResult} results'
    },
    loading: {
        id: 'ml.gateway.views.MLViewAllPoliciesPage.Loading...',
        defaultMessage: 'Loading...'
    },
    noPoliciesToShow: {
        id: 'ml.gateway.views.MLViewAllPoliciesPage.No policies to show',
        defaultMessage: 'No policies to show'
    },
    errorPermissionGroup: {
        id: 'ml.gateway.views.MLViewAllPoliciesPage.Error Permission Group',
        defaultMessage: 'We are unable to retrieve information for this group. You may not have access or this group is invalid'
    },
    effectiveDateRange: {
        id: 'ml.gateway.views.MLViewAllPoliciesPage.Effective Date Range',
        defaultMessage: 'Effective Date Range'
    },
    allPolicies: {
        id: 'ml.gateway.views.MLViewAllPoliciesPage.All Policies',
        defaultMessage: 'All Policies'
    }
});
